import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EstoqueService } from 'src/app/service/estoque.service';
import { ProductService } from 'src/app/service/product.service';
import { FornecedorService } from 'src/app/service/fornecedor.service';
import { Estoque } from './estoque';

@Component({
  selector: 'app-estoque-form',
  templateUrl: './estoque-form.component.html',
  styleUrls: ['./estoque.component.scss'],
})
export class EstoqueFormComponent implements OnInit {

  formulario: FormGroup;
  mensagemErros: String[] = [];
  nameProduct: string;
  nameFornecedor: string;
  carregando = false;

  constructor(
    private estoqueService: EstoqueService,
    private formBilder: FormBuilder,
    private snackBar: MatSnackBar,
    private productService: ProductService,
    private fornecedorService: FornecedorService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.montarFormulario();

    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.carregar(+id);
    }
  }

  limparFormulario() {
    this.router.navigate(['/estoque/form']);
    this.montarFormulario();
    this.nameProduct = '';
    this.nameFornecedor = '';
  }

  submit() {
    const formValues = this.formulario.value;
    const estoque: Estoque = new Estoque(
      formValues.id,
      formValues.product,
      formValues.supplier,
      formValues.qdtProduct,
      formValues.amountPaid,
      formValues.invoiceNumber,
      formValues.obser,
      formValues.fornecedor,
      formValues.produto,
      formValues.createdAt);

    if (formValues.id) {
      this.estoqueService.update(estoque).subscribe(() => {
        this.snackBar.open('Entrada alterado com sucesso!', 'Sucesso', {
          duration: 2000
        });
        this.voltarConsulta();
      }, errorResponse => {
        this.snackBar.open(errorResponse.error.message, 'ERRO', {
          duration: 2000
        });
      });
    } else {
      this.estoqueService.save(estoque).subscribe(() => {
        this.snackBar.open('Entrada salvo com sucesso!', 'Sucesso', {
          duration: 2000
        });
        this.voltarConsulta();
      }, errorResponse => {
        this.snackBar.open(errorResponse.error.message, 'ERRO', {
          duration: 2000
        });
      });
    }
  }

  montarFormulario() {
    this.formulario = this.formBilder.group({
      id: [null, Validators.nullValidator],
      product: [null, Validators.nullValidator],
      supplier: [null, Validators.nullValidator],
      qdtProduct: [null, Validators.nullValidator],
      amountPaid: [null, Validators.nullValidator],
      invoiceNumber: [null],
      obser: [null]
    });
  }

  carregar(id: number) {
    this.carregando = true;
    this.estoqueService.findClientById(id).subscribe((response) => {
      this.formulario.controls.id.setValue(id);
      this.formulario.controls.product.setValue(response.product);
      this.formulario.controls.supplier.setValue(response.supplier);
      this.formulario.controls.qdtProduct.setValue(response.qdtProduct);
      this.formulario.controls.amountPaid.setValue(response.amountPaid);
      this.formulario.controls.invoiceNumber.setValue(response.invoiceNumber);
      this.formulario.controls.obser.setValue(response.obser);
      if (this.formulario.contains('fornecedor')) {
        this.formulario.controls.fornecedor.setValue(response.fornecedor);
      }
      if (this.formulario.contains('produto')) {
        this.formulario.controls.produto.setValue(response.produto);
      }
      if (this.formulario.contains('createdAt')) {
        this.formulario.controls.createdAt.setValue(response.createdAt);
      }
      this.nameFornecedor = response.fornecedor ?? '';
      this.nameProduct = response.produto ?? '';
      this.carregando = false;
    }, () => {
      this.carregando = false;
      this.snackBar.open('Entrada de estoque não encontrada.', 'ERRO', { duration: 2500 });
      this.voltarConsulta();
    });
  }

  buscarProduto() {
    const formValues = this.formulario.value;
    this.productService.findProductByIdActive(formValues.product).subscribe((response) => {
      this.nameProduct = response.name;
    }, errorResponse => {
      this.snackBar.open(errorResponse.error.message, 'ERRO', {
        duration: 3000
      });
    });
  }

  buscarFornecedor() {
    const formValues = this.formulario.value;
    this.fornecedorService.findFornecedorById(formValues.supplier).subscribe((response) => {
      this.nameFornecedor = response.razaoSocial;
    }, errorResponse => {
      this.snackBar.open(errorResponse.error.message, 'ERRO', {
        duration: 3000
      });
    });
  }

  voltarConsulta() {
    this.router.navigate(['/estoque/consulta']);
  }
}
